<script lang="ts">
    import {exists} from 'shared/utils/custom-utils';
    import {getFormattedProjectNameParts} from 'src/features/erp-sutor/features/project-record-detail/utils';
    import GenericRecordDetailTopbar from 'src/features/erp-sutor/features/generic-record-detail/components/GenericRecordDetailTopbar.svelte';
</script>

<GenericRecordDetailTopbar {...$$restProps}>
    <svelte:fragment slot="record-name" let:record>
        {@const nameParts = getFormattedProjectNameParts(record)}

        <span class="project-name">
            {nameParts.name}
        </span>

        {#if exists(nameParts.projectNumber)}
            <span>-</span>
            <span class="text-muted">{nameParts.projectNumber}</span>
        {/if}
    </svelte:fragment>
</GenericRecordDetailTopbar>

<style lang="less">
    .project-name {
        font-weight: 500;
    }
</style>